/**
 * Configuration for data time modules used in the time filter API
 * Maps each page/tab to its corresponding data modules
 */

export interface DataTimeModuleConfig {
  [key: string]: string[];
}

// Global minimum date for all date pickers (Format: 'YYYY-MM')
export const GLOBAL_MIN_DATE = '2025-10';

// Module configuration by page/tab
export const DATA_TIME_MODULES: DataTimeModuleConfig = {
  // Portfolio Overview page modules
  portfolio: [
    'studio_revenue',
    'studio_profit',
    'portfolio_burn_rate',
    'portfolio_staff_rate',
    'portfolio_headcount',
    // 'portfolio_note',
  ],

  // Studios page modules
  studio: [
    'studios_revenue',
    'studios_profit',
    // 'studios_note',
    'studios_staff_rate',
    'studios_burn_rate',
    'studios_headcount',
  ],

  // Live Titles (business) — month picker lives in child pages; keep empty here.
  titles: [],

  // Live Titles Finance default month only (fetched in LiveFinance hook).
  titles_finance: ['live_title_finance'],

  // InDev Projects page modules
  projects: [
    'indev_total_spent',
    'indev_headcount',
    // 'indev_lifecycle',
    // 'indev_note',
    // 'indev_gr',
  ],
};

// Publishing Management modules
export const PUBLISHING_MODULES: DataTimeModuleConfig = {
  overview: [
    'publishing_revenue',
    'publishing_profit',
    // 'publishing_appendix',
    'decision_list',
  ],

  mktCost: [
    'mkt_total',
    'mkt_revenue',
    'mkt_project',
  ],

  publishingHeadcount: [
    'publishing_headcount',
    // 'headcount_note',
    // 'headcount_appendix',
  ],

  publishingProject: [
    'project_headcount',
    'project_revenue',
    'project_mkt',
    'project_tech',
    // 'project_appendix',
  ],
};

/**
 * Get modules for a specific page/tab
 */
export const getModulesForPage = (page: string): string[] => {
  return DATA_TIME_MODULES[page] || [];
};

/**
 * Get modules for Publishing Management pages
 */
export const getPublishingModulesForPage = (page: string): string[] => {
  return PUBLISHING_MODULES[page] || [];
};

// ── Download modal modules ──────────────────────────────────────────────
// Independent of page-level modules; these define which data-time range
// the MetricsDownloadModal should use when constraining the month picker.

export const DOWNLOAD_MODULES: DataTimeModuleConfig = {
  portfolio: [
    'portfolio_burn_rate',
    'portfolio_staff_rate',
    'portfolio_headcount',
  ],

  studio: [
    'studios_revenue',
    'studios_profit',
    'studios_staff_rate',
    'studios_burn_rate',
    'studios_headcount',
  ],

  // LiveFinance Financial Data Download
  finance: ['live_title_finance'],
};

/**
 * Get modules for the MetricsDownloadModal by scope.
 */
export const getModulesForDownload = (
  scope: 'portfolio' | 'studio' | 'finance',
): string[] => {
  return DOWNLOAD_MODULES[scope] || [];
};
